import { Component } from '@angular/core';

@Component({
  selector: 'greco-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss'],
})
export class BoxComponent {}
